/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DistributedRewardSubject {
    OVERWOLFREWARD = 'OVERWOLF_REWARD',
    QUESTPROGRESSAUTOREWARD = 'QUEST_PROGRESS_AUTO_REWARD',
    MANUALDISTRIBUTION = 'MANUAL_DISTRIBUTION',
    SPONSOREDCOMPETITIONREWARD = 'SPONSORED_COMPETITION_REWARD',
    LOOTBOXREWARD = 'LOOTBOX_REWARD',
    OVERWOLFTIMEREWARD = 'OVERWOLF_TIME_REWARD',
    CHALLENGEREWARD = 'CHALLENGE_REWARD',
    PRIZEPOOL = 'PRIZE_POOL'
}

export function DistributedRewardSubjectFromJSON(json: any): DistributedRewardSubject {
    return DistributedRewardSubjectFromJSONTyped(json, false);
}

export function DistributedRewardSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributedRewardSubject {
    return json as DistributedRewardSubject;
}

export function DistributedRewardSubjectToJSON(value?: DistributedRewardSubject | null): any {
    return value as any;
}

